// Libraries
import { Fragment } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faComment, faCommentSlash } from '@fortawesome/pro-solid-svg-icons';

// Hooks
import { useAppSelector, useAppDispatch } from '../../../app/hooks';

// Features
import { selectPlayerList } from '../../../features/session/sessionSlice';
import { pushPlayersListStatus } from '../../../features/app/appSlice';
import {
    selectUser,
    putUserAsync,
    // postAbusiveUserAsync,
} from '../../../features/user/userSlice';

// Components
import Menu from '../Menu/Menu';

// Utilities
import sortByObjectProp from '../../../utils/object/sortByObjectProp';

// Styles
import styles from './PlayersList.module.css';

/**
 * @function PlayersList
 * List of active players in session
 *
 * @example
 * return (
 *   <PlayersList />
 * )
 */
function PlayersList(): JSX.Element {
    const currentUser = useAppSelector(selectUser);
    const players = useAppSelector(selectPlayerList);
    const dispatch = useAppDispatch();
    const playersSorted = sortByObjectProp(players, 'username');
    let prevCapital: string = '';

    function handlePlayersClick(value: boolean) {
        dispatch(pushPlayersListStatus(value));
    }

    function handleBlockClick(event: any, blockedUserId: number) {
        const blockedUserString = `/api/v2/users/${blockedUserId}`;
        const newBlockList = currentUser.blocked.includes(blockedUserString)
            ? currentUser.blocked.filter((item) => item !== blockedUserString)
            : [blockedUserString, ...currentUser.blocked];

        console.log(newBlockList);

        dispatch(
            putUserAsync({
                user: { ...currentUser, blocked: newBlockList },
            }),
        );
    }

    return (
        <Menu
            header={
                <>
                    <h2>
                        These are the <b>{playersSorted.length}</b> players in
                        this session
                    </h2>
                    <figure className={styles.figure}>
                        <img
                            src={`https://${process.env.REACT_APP_CDN}/play-bingo/images/graphics/graphic-player-ball.svg`}
                            alt=""
                        />
                        <figcaption>{playersSorted.length}</figcaption>
                    </figure>
                </>
            }
            onClose={() => handlePlayersClick(false)}
        >
            <ul className={styles.list}>
                {playersSorted.map(({ id = 0, username = '' }) => {
                    const capital: string = username.split('')[0].toUpperCase();
                    const capitalMatch: boolean = capital === prevCapital;
                    const userId = id;
                    if (!capitalMatch) prevCapital = capital;
                    return (
                        <Fragment key={userId}>
                            {!capitalMatch && (
                                <li className={styles.listhead}>{capital}</li>
                            )}
                            <li>
                                {username}
                                {currentUser.id !== userId && (
                                    <div className={styles.buttons}>
                                        {currentUser.blocked.filter(
                                            (id) =>
                                                id ===
                                                `/api/v2/users/${userId}`,
                                        ).length === 0 ? (
                                            <button
                                                type="button"
                                                onClick={(event) =>
                                                    handleBlockClick(event, id)
                                                }
                                            >
                                                <FontAwesomeIcon
                                                    icon={faComment}
                                                    fixedWidth
                                                />
                                            </button>
                                        ) : (
                                            <button
                                                type="button"
                                                className={styles.active}
                                                onClick={(event) =>
                                                    handleBlockClick(event, id)
                                                }
                                            >
                                                <FontAwesomeIcon
                                                    icon={faCommentSlash}
                                                    fixedWidth
                                                />
                                            </button>
                                        )}
                                    </div>
                                )}
                            </li>
                        </Fragment>
                    );
                })}
            </ul>
        </Menu>
    );
}

// Exports
export default PlayersList;
